





































































import { defineComponent, computed } from '@nuxtjs/composition-api';
import { useHeader, useTranslations } from '@vue-storefront/novulo';
import { addCurrency, priceFormat } from '~/helpers/utils';

export default defineComponent({
  name: 'MiniCartDrawer',
  props: {
    isOpen: { type: Boolean, default: false },
    product: { type: Object, default: null },
    cartItemId: { type: Number, default: null },
    cartItemIsInsured: { type: Boolean, default: null },
    isLoading: { type: Boolean, default: false },
    itemsCount: { type: Number, default: 0 },
    totalPrice: { type: Number, default: 0 },
    totalsLoading: { type: Boolean, default: false }
  },
  setup(props, { emit }) {
    const { translate } = useTranslations();
    const { headerResult } = useHeader();

    const hasRelated = computed(() =>
      props.product &&
      Array.isArray((props.product as any).related_products) &&
      (props.product as any).related_products.length > 0
    );

    const onAddAccessory = (payload: any) => {
      handleAddAccessory(payload.product);
    };

    function handleAddAccessory(p: any) {
      // console.warn('handleAddAccessory', p);
    }

    const relatedProducts = computed(() => {
      if (
        props.product &&
        Array.isArray((props.product as any).related_products)
      ) {
        return (props.product as any).related_products.slice(0, 5);
      }
      return [];
    });

    const closeDrawer = () => {
      emit('close');
    };

    const cartLink = computed(() => {
      const fallback = '#';
      try {
        const urlsContainer = headerResult.value?.find((item: any) => item.code === 'header_shoppingcart');
        const urls = urlsContainer?.elements?.[0]?.urls || [];
        const cart = urls.find((u: any) => u.code_english === 'cart_page');
        return cart?.url || fallback;
      } catch {
        return fallback;
      }
    });

    const showCarePlan = computed(() => props.product.insurance_product && props.product.insurance_product.description);

    const goToCart = () => {
      window.location.href = cartLink.value;
    };

    return {
      addCurrency,
      closeDrawer,
      goToCart,
      hasRelated,
      onAddAccessory,
      priceFormat,
      relatedProducts,
      showCarePlan,
      translate
    };
  }
});
